module.exports = __webpack_public_path__ + "img/p3-1-1.94a8963a.png";